export interface IVehicleShopVehicle {
	model: string;
	priceCash: number;
	priceDonate?: number;
	priceTestDrive: number;
	name: string;
	specs: IVehicleShopSpecs;
	tags?: {
		new?: boolean;
		discount?: number;
		onlyCase?: boolean;
	};
	caseName?: string;
}

export interface IVehicleShopSpecs {
	fuelTankCapacity: number;
	fuelConsumptionRate: number;
	trunkVolume: number;
	maxSpeed: number;
	passengerSeats: number;
}

export enum VehicleShopType {
	LOW = 'low',
	REGULAR = 'regular',
	EXPENSIVE = 'expensive',
	WORK = 'work',
}

export interface IVehicleShopInfo {
	id: VehicleShopType;
	name: string;
	title: string;

	maxVehicleSpeed: number;
	maxTrunkVolume: number;
	maxFuelTankCapacity: number;

	testDriveDurationSec: number;

	vehicles: IVehicleShopVehicle[];
}

export interface IVehicleShopOffer {
	title: string;
	description: string;
	caseId: string;
	color: string;
}
